import { resetSwapForm, useWLOrderFormDispatch } from '@talos/kyoko';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cancelBalanceTransactionThunk } from './cancelBalanceTransactionThunk';

export function useCancelBalanceTransaction() {
  const dispatch = useWLOrderFormDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const cancelBalanceTransaction = useCallback(async () => {
    const response = await dispatch(cancelBalanceTransactionThunk());
    dispatch(resetSwapForm({ keepFromQty: true }));
    if (cancelBalanceTransactionThunk.fulfilled.match(response)) {
      // if we are in verify flow, we should navigate back to previous page
      if (pathname.includes('verify')) {
        navigate(-1);
      }
    }
  }, [dispatch, pathname, navigate]);

  return cancelBalanceTransaction;
}
